import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const PRICING_POLICIES_LIST_QUERY = gql`
	query PricingPolicies($first: Int, $after: String) {
		pricingPolicies(first: $first, after: $after) {
			nodes {
				pricingPolicyId
				name
				priority
				isActive
				scenario {
					scenarioId
					name
				}
				tariff {
					tariffId
					name
				}
				overstayTariff {
					tariffId
					name
				}
				limit {
					limitId
					name
				}
				billingCycle {
					billingCycleId
					name
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const PRICING_POLICY_QUERY = gql`
	query PricingPolicy($id: Ulid!) {
		pricingPolicy(pricingPolicyId: $id) {
			pricingPolicyId
			name
			priority
			isActive
			activatedAt
			deactivatedAt
			scenario {
				scenarioId
				name
			}
			tariff {
				tariffId
				name
			}
			overstayTariff {
				tariffId
				name
			}
			limit {
				limitId
				name
				maxAmount
				minAmount
				maxStayMinutes
				minStayMinutes
			}
			billingCycle {
				billingCycleId
				name
			}
		}
	}
`;

export const PRICING_POLICY_DELETE_MUTATION = gql`
	mutation DeletePricingPolicy($input: DeletePricingPolicyInput!) {
		deletePricingPolicy(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['pricingPolicies'] = {
	document: PRICING_POLICIES_LIST_QUERY,
	dataPath: 'pricingPolicies'
};

viewResourceQueryDefinitions['pricingPolicies'] = {
	document: PRICING_POLICY_QUERY,
	dataPath: 'pricingPolicy'
};

deleteResourceMutationDefinitions['pricingPolicies'] = {
	document: PRICING_POLICY_DELETE_MUTATION,
	operation: 'deletePricingPolicy',
	getVariables: variables => ({ input: variables })
};
